import {
  LEGAL_DATA_PROTECTION_DE,
  LEGAL_PRIVACY_POLICY_LINK_ES,
  LEGAL_PRIVACY_POLICY_LINK_IT,
  NEWSLETTER_LEGAL_PRIVACY_POLICY_LINK_PT,
  NEWSLETTER_LEGAL_PRIVACY_POLICY_LINK_NL,
  NEWSLETTER_LEGAL_PRIVACY_POLICY_LINK_FR,
} from './links.constants';

export const enum CountryCode {
  Germany = 'de',
  Spain = 'es',
  Italy = 'it',
  Portugal = 'pt',
  Netherlands = 'nl',
  France = 'fr',
}

export const enum CountryValueForDropDown {
  Germany = 'DEU',
  Spain = 'ESP',
  Italy = 'ITA',
  Portugal = 'PRT',
  Netherlands = 'NLD',
  France = 'FRA',
}

export const enum MarketName {
  Metro = 'metro',
  Makro = 'makro',
}

export const enum COUNTRY_VALUES_FOR_PREFILLING {
  Netherlands = 'Nederland',
  France = 'France',
}

export const DEFAULT_COUNTRIES_PER_MARKET = {
  [CountryCode.Germany]: CountryValueForDropDown.Germany,
  [CountryCode.Spain]: CountryValueForDropDown.Spain,
  [CountryCode.Italy]: CountryValueForDropDown.Italy,
  [CountryCode.Portugal]: CountryValueForDropDown.Portugal,
  [CountryCode.Netherlands]: CountryValueForDropDown.Netherlands,
  [CountryCode.France]: CountryValueForDropDown.France,
};

export const legalLink = {
  [CountryCode.Germany]: LEGAL_DATA_PROTECTION_DE,
  [CountryCode.Spain]: LEGAL_PRIVACY_POLICY_LINK_ES,
  [CountryCode.Italy]: LEGAL_PRIVACY_POLICY_LINK_IT,
  [CountryCode.Portugal]: NEWSLETTER_LEGAL_PRIVACY_POLICY_LINK_PT,
  [CountryCode.Netherlands]: NEWSLETTER_LEGAL_PRIVACY_POLICY_LINK_NL,
  [CountryCode.France]: NEWSLETTER_LEGAL_PRIVACY_POLICY_LINK_FR,
};

export const COUNTRY_BASED_VAT_ID_PREFIX = {
  [CountryCode.Italy]: 'IT',
  [CountryCode.Portugal]: 'PT',
  [CountryCode.Germany]: 'DE'
};

export const COUNTRY_BASED_MARKET_NAME = {
  [CountryCode.Germany]: MarketName.Metro,
  [CountryCode.Spain]: MarketName.Makro,
  [CountryCode.Italy]: MarketName.Metro,
  [CountryCode.Portugal]: MarketName.Makro,
  [CountryCode.Netherlands]: MarketName.Makro,
  [CountryCode.France]: MarketName.Metro,
};

export const COUNTRIES_WITH_DATA_PREFILLING_ON_TIER_TWO = {
  [CountryCode.Italy]: true,
  [CountryCode.Portugal]: true,
  [CountryCode.Netherlands]: true,
  [CountryCode.France]: true,
};
